import { RELEASE_FLAGS, releaseFlagOn, type ReleaseFlagName } from '../config/release-flags';
import { targetsProductionBackend } from '../util/env';
import { useScopeRole } from './useEntityScope';

/**
 * Whether this viewer sees a release-flagged feature (`config/release-flags.ts`).
 * Reads the role in the account this tab is looking at, so a switch or a
 * Log In As re-renders the caller with the new answer.
 */
export const useReleaseFlag = (name: ReleaseFlagName): boolean => {
  const role = useScopeRole();
  return releaseFlagOn(RELEASE_FLAGS[name], {
    role,
    productionBackend: targetsProductionBackend()
  });
};
